export const removeQueryParamFromCurrentUrl = (key: string) => {
  const searchParams = new URLSearchParams(window?.location.search);
  if (searchParams?.has(key)) {
    searchParams.delete(key);
    const newSearch = searchParams.toString();
    const newUrl = `${window.location.pathname}${newSearch ? '?' : ''}${newSearch}`;
    window.history.replaceState(window.history.state, document.title, newUrl);
  }
};
